import { Component, Input, OnInit } from '@angular/core';
import { Registration } from 'src/app/models/registration';
import { QuickSignupService } from 'src/app/services/quick-signup-service';
import { SavedPlatesService } from 'src/app/services/saved-plates.service';
import { TrackPlateService } from 'src/app/services/track-plate.service';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'pla-inline-favourite',
  templateUrl: './inline-favourite.component.html',
  styleUrls: ['./inline-favourite.component.scss']
})
export class InlineFavouriteComponent implements OnInit {

  // The heart is Save (shared shortlist, no sign-in) and the bell is Track plate,
  // on every host: on release hosts SavedPlatesService / TrackPlateService map
  // signed-in users to the legacy favourite/notify lists themselves.
  public readonly useNew = true;
  public loading: boolean = false;
  // Two-step stop so a stray click never silently drops tracking (as on the
  // plate page): the first click asks "Stop tracking?", the second stops.
  public stopArmed = false;
  private stopTimer: any = null;
  @Input() public plate: Registration;
  @Input() public showText: boolean = true;
  @Input() public force: 'favourite' | 'notify' | 'none' = 'none';
  constructor(
    private signupService: QuickSignupService,
    private userService: UserService,
    private savedPlates: SavedPlatesService,
    private trackPlate: TrackPlateService
  ) { }

  ngOnInit(): void {
    if (this.useNew) this.trackPlate.refresh(false);
  }

  public get isFavourite(): boolean {
    return this.useNew ? this.savedPlates.isSaved(this.plate?.registration) : !!this.plate?.favourite;
  }

  public get isNotify(): boolean {
    return this.useNew ? this.trackPlate.isTracked(this.plate?.registration) : !!this.plate?.notify;
  }

  public get busy(): boolean {
    if (!this.useNew) return this.loading;
    const reg = this.plate?.registration;
    return this.savedPlates.isBusy(reg) || this.trackPlate.isBusy(reg);
  }

  public handleFavouriteRegistration(): void {
    if (this.useNew) {
      this.savedPlates.toggle(this.plate.registration).subscribe();
      return;
    }
    this.signupService.quickSignup(`favourite ${this.plate.formattedRegistration}`, undefined, (status: boolean) => {
      if (status) this.favouriteRegistration();
    }, () => { }, { action: 'favourite', registration: this.plate.formattedRegistration });
  }

  public handleNotifyRegistration(): void {
    if (this.useNew) {
      if (this.isNotify) {
        if (!this.stopArmed) {
          this.stopArmed = true;
          clearTimeout(this.stopTimer);
          this.stopTimer = setTimeout(() => (this.stopArmed = false), 3500);
          return;
        }
        this.stopArmed = false;
        this.trackPlate.untrack(this.plate.registration).subscribe();
        return;
      }
      this.trackPlate.track(this.plate.registration, this.plate.formattedRegistration);
      return;
    }
    this.signupService.quickSignup(`notify ${this.plate.formattedRegistration}`, undefined, (status: boolean) => {
      if (status) this.notifyRegistration();
    }, () => { }, { action: 'notify', registration: this.plate.registration });
  }

  public get trackLabel(): string {
    if (this.stopArmed) return 'Stop tracking?';
    return this.isNotify ? 'Tracking' : 'Track';
  }

  public canShowFavourite(): boolean {
    if (this.force === 'notify') return false;
    if (this.force === 'favourite') return true;
    if (this.plate.available && this.plate.price > 0) return true;
    return false;
  }

  public canShowNotify(): boolean {
    if (this.force === 'favourite') return false;
    if (this.force === 'notify') return true;
    if (!this.plate.available || this.plate.price <= 0) return true;
    return false;
  }

  public notifyRegistration(): void {
    var reg = this.plate;
    reg.notify = !reg.notify; // UI update
    this.loading = true;
    this.userService.notifyRegistration(reg, (notifies: Registration[]) => {
      var _filteredNotifies = notifies.filter(
        (f) =>
          f.registration.replace(' ', '') == reg.registration.replace(' ', '')
      );
      reg.notify = _filteredNotifies && _filteredNotifies.length > 0;
      this.loading = false;
    });
  }

  public favouriteRegistration(): void {
    var reg = this.plate;
    reg.favourite = !reg.favourite; // UI update
    this.loading = true;
    this.userService.favouriteRegistration(reg, (favs: Registration[]) => {
      var _filteredFavourites = favs.filter(
        (f) =>
          f.registration.replace(' ', '') == reg.registration.replace(' ', '')
      );
      reg.favourite = _filteredFavourites && _filteredFavourites.length > 0;
      this.loading = false;
    });
  }

}
